import React from "react";

function PrivacyPolicy() {
    return (
        <div className="d-flex justify-content-center m-5 pt-5">
            <div className="card privacy-card">
                <div className="card-body">
                    <h2 className="card-title text-center privacy-title">
                        Privacy Policy for Contact Form & Account Sign-Up
                    </h2>

                    <div className="card-text">
                        <h5>1. Information We Collect</h5>
                        <p>When you interact with Luxora, we may collect the following personal information:</p>

                        <strong>A. When You Submit a Message (Contact Us Form):</strong>
                        <ul>
                            <li>Full Name (to personalize communication)</li>
                            <li>Email Address (to respond to inquiries)</li>
                            <li>Phone Number (for direct communication, if necessary)</li>
                            <li>Message Content (to understand and address your inquiry)</li>
                        </ul>

                        <strong>B. When You Sign Up for an Account:</strong>
                        <ul>
                            <li>Full Name (for personalization)</li>
                            <li>Email Address (for login, communication, and account recovery)</li>
                            <li>Phone Number (for authentication and support)</li>
                            <li>Password (encrypted for security)</li>
                            <li>Saved Preferences (e.g., favorite properties, alerts)</li>
                        </ul>

                        <h5>2. How We Use Your Information</h5>
                        <p>Your data is collected for the following purposes:</p>
                        <ul>
                            <li><strong>For inquiries:</strong> Responding to messages and providing customer support.
                            </li>
                            <li><strong>For accounts:</strong> Creating and managing your Luxora profile, allowing
                                secure login, and enabling property-saving features.
                            </li>
                            <li><strong>For marketing:</strong> Sending property alerts, investment insights, and
                                promotional content (if opted in).
                            </li>
                            <li><strong>For personalization:</strong> Tailoring your Luxora experience based on
                                preferences and interactions.
                            </li>
                            <li><strong>For security & compliance:</strong> Preventing fraud, protecting your account,
                                and complying with legal regulations.
                            </li>
                        </ul>

                        <h5>3. Marketing & Communication Preferences</h5>
                        <p>By submitting your information, you may receive emails, text messages, or phone calls related
                            to Luxora’s real estate services. Some of these communications may be automated. You can opt
                            out at any time:</p>
                        <ul>
                            <li>To stop SMS messages, reply <strong>“STOP”</strong> to any text.</li>
                            <li>To unsubscribe from emails, click the **unsubscribe** link in any email.</li>
                            <li>To opt out of calls, request removal by contacting us.</li>
                        </ul>

                        <h5>4. Data Protection & Security</h5>
                        <ul>
                            <li>Passwords are encrypted and not accessible by anyone, including us.</li>
                            <li>Secure data transmission is ensured using encryption protocols.</li>
                            <li>Strict access controls prevent unauthorized use of your data.</li>
                        </ul>

                        <h5>5. Information Sharing & Third Parties</h5>
                        <p>We do not sell, rent, or trade your personal data. However, we may share it with:</p>
                        <ul>
                            <li>Trusted service providers (e.g., email, SMS, authentication) for service
                                functionality.
                            </li>
                            <li>Legal authorities if required by law or to prevent fraud.</li>
                        </ul>

                        <h5>6. Your Rights & Choices</h5>
                        <ul>
                            <li>Access, update, or delete your information through your account settings or by
                                request.
                            </li>
                            <li>Change your communication preferences at any time.</li>
                            <li>Request account deactivation and data removal.</li>
                            <li>Withdraw consent for marketing communications.</li>
                        </ul>

                        <h5>7. Account Deletion</h5>
                        <p>If you wish to delete your Luxora account, you can do so via account settings or by
                            contacting support. Your data will be removed except where retention is legally required
                            (e.g., fraud prevention, tax compliance).</p>

                        <h5>8. Updates to This Policy</h5>
                        <p>Luxora may update this Privacy Policy from time to time. Changes will be reflected on this
                            page with a revised effective date.</p>

                        <h5>9. Contact Us</h5>
                        <p>For any privacy-related questions or requests, reach out to us at:</p>
                        <ul>
                            <li>
                                <i className="bi bi-envelope"></i>enquiries@luxoradubai.com
                            </li>
                            <li>
                                <i className="bi bi-telephone"></i>+1 732-983-7089<br/>
                                +971 585644456
                            </li>
                            <li>
                                <i className="bi bi-geo-alt"></i>Metropolis Tower, Office Number 215<br/>
                                Business Bay, Dubai, United Arab Emirates
                            </li>
                        </ul>

                        <p><strong>Last Updated: January 30,2025</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;